import { Grid, TextField, Typography, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material';
import { Field } from 'formik';
import { VEHICLE_TYPE_OPTIONS } from '../../constants/vehicleConstants';

interface FormContentProps {
  values: any;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  mode: 'create' | 'edit';
  isAdmin: boolean;
  authUser: any;
  setFieldValue: (field: string, value: any) => void;
}

export function FormContent({ 
  values, 
  errors, 
  touched, 
  isSubmitting, 
  mode, 
}: FormContentProps) {
  const theme = useTheme();
  
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2}>
          Dados Básicos
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Marca"
          name="marca"
          required
          disabled={isSubmitting}
          error={!!(touched.marca && errors.marca)}
          helperText={touched.marca && errors.marca}
          placeholder="Ex: Toyota"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Modelo"
          name="modelo"
          required
          disabled={isSubmitting}
          error={!!(touched.modelo && errors.modelo)}
          helperText={touched.modelo && errors.modelo}
          placeholder="Ex: Corolla"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          select
          fullWidth
          label="Tipo"
          name="tipo"
          required
          disabled={isSubmitting}
          error={!!(touched.tipo && errors.tipo)}
          helperText={touched.tipo && errors.tipo}
        >
          {VEHICLE_TYPE_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Field>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Placa"
          name="placa"
          required
          disabled={isSubmitting}
          error={!!(touched.placa && errors.placa)}
          helperText={touched.placa && errors.placa}
          placeholder="Ex: ABC1234 ou ABC1D23"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Ano"
          name="ano"
          type="number"
          required
          disabled={isSubmitting}
          error={!!(touched.ano && errors.ano)}
          helperText={touched.ano && errors.ano}
          inputProps={{ min: 1900, max: new Date().getFullYear() + 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Cor"
          name="cor"
          required
          disabled={isSubmitting}
          error={!!(touched.cor && errors.cor)}
          helperText={touched.cor && errors.cor}
          placeholder="Ex: Branco"
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          as={TextField}
          fullWidth
          label="Observações"
          name="observacoes"
          multiline
          rows={3}
          disabled={isSubmitting}
          error={!!(touched.observacoes && errors.observacoes)}
          helperText={touched.observacoes && errors.observacoes}
          placeholder="Observações adicionais sobre o veículo..."
        />
      </Grid>
    </Grid>
  );
} 